import type { MainModule } from '~/types'
import { createVuestic } from 'vuestic-ui'
import vuesticGlobalConfig from '~/services/vuestic-ui/global-config'

export const install: MainModule = ({ _isClient, _initialState, app }) => {
  app.use(createVuestic({ config: vuesticGlobalConfig }))
}
